// @flow
import { type Reducer } from './Reducers';

export const injectReducers = (store, reducers: { [string]: Reducer }) => {
    const reducersToInject = [];
    for (const key in reducers) {
        reducersToInject.push({ key, reducer: reducers[key] });
    }
    store.reducers.add(reducersToInject);
    // NOTE: here we are calling replaceReducer just to init the state of new reducers with the default one
    // internall replaceReducer dispatches action which will init the state
    store.replaceReducer(store.rootReducer);

    return function removeReducers() {
        const reducersToRemove = [];
        for (const key in reducers) {
            reducersToRemove.push(key);
        }
        store.reducers.remove(reducersToRemove);
        store.replaceReducer(store.rootReducer);
    };
};
